<template>
    <div class="me-page">
        <AnimatedContent :distance="24" :duration="0.7">
            <section class="me-invite">
                <h2>{{ $t('me.inviteLink') }}</h2>
                <div class="me-invite__field">
                    <span >
                        <!-- {{inviteLink}} -->
                        {{ inviteLink.slice(0,42) }}<br />{{ inviteLink.slice(42) }}
                        </span>
                    <button type="button" @click="copy(inviteLink)">
                        <img src="@/assets/img/me/icon-copy.png" alt="">
                    </button>
                </div>
                <h3>{{ $t('me.upline') }}</h3>
                <div class="me-invite__field">
                    <span style="font-size:11px">{{ upline }}</span>
                    <button type="button" @click="copy(upline)">
                        <img src="@/assets/img/me/icon-copy.png" alt="">
                    </button>
                </div>
            </section>
        </AnimatedContent>

        <AnimatedContent :distance="22" :duration="0.65" :delay="0.08">
            <div class="me-grid">
               
                <div >
                    <span class="me-grid__deco" ></span>
                    <p>
                        <img src="@/assets/img/me/icon-invite.png" alt="">
                        <span>{{$t('me.inviteCount') }}<em ></em></span>
                    </p>
                    <strong>
                        {{recommandCount}}
                    </strong>
                </div>

                <div >
                    <span class="me-grid__deco" ></span>
                    <p>
                        <img src="@/assets/img/me/icon-team.png" alt="">
                        <span>{{$t('me.teamCount') }}<em ></em></span>
                    </p>
                    <strong>
                        {{teamCount}}
                    </strong>
                </div>

                <div >
                    <span class="me-grid__deco" ></span>
                    <p>
                        <img src="@/assets/img/me/icon-big.png" alt="">
                        <span>{{$t('me.bigArea') }}<em ></em></span>
                    </p>
                    <strong>
                        {{Number(bigPower).toFixed(2)}}
                    </strong>
                </div>
                <div >
                    <span class="me-grid__deco" ></span>
                    <p>
                        <img src="@/assets/img/me/icon-small.png" alt="">
                        <span>{{$t('me.smallArea') }}<em ></em></span>
                    </p>
                    <strong>
                        {{Number(smallPower).toFixed(2)}}
                    </strong>
                </div>
            </div>
        </AnimatedContent>

        <FadeContent :blur="false" :delay="80" :duration="800">
            <section class="me-card">
                <h2>{{ $t('me.team') }}</h2>
                <FadeContent
                    v-for="(item, index) in userList"
                    :key="item.id"
                    :delay="80 * index"
                    :duration="500"
                >
                    <div class="me-member" :class="{ 'is-split': index > 0 }">
                        <div class="me-member__top">
                            <span class="me-member__addr">{{ item.Addr }}</span>
                            <!-- <em :class="item.tag">{{ $t('me.' + item.tag) }}</em> -->
                        </div>
                        <div class="me-member__nums">
                            <div>
                                <label>{{ $t('me.personT') }}</label>
                                <strong>{{ Number(item.rsPower).toFixed(2) }}</strong>
                            </div>
                            <div>
                                <label>{{ $t('me.teamBurn') }}</label>
                                <strong>{{ Number(item.teamPower).toFixed(2) }}</strong>
                            </div>
                            <div class="me-member__remark" @click="openRemark(item)">
                                <label>{{ $t('me.remark') }}</label>
                                <button type="button">
                                    {{ item.remark }}
                                    <svg class="me-member__edit" viewBox="0 0 14 14" width="14" height="14" aria-hidden="true">
                                        <path d="M8.2 2.1l3.7 3.7-7.4 7.4H.8V9.5l7.4-7.4z" fill="none" stroke="#101126" stroke-width="1.2" stroke-linejoin="round"/>
                                        <path d="M7.1 3.2l3.7 3.7" stroke="#101126" stroke-width="1.2"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </FadeContent>
            </section>
        </FadeContent>

        <Popup v-model="remarkShow" round get-container="#app" class="me-remark-popup">
            <div class="me-dialog">
                <h3>{{ $t('me.setRemark') }}</h3>
                <div class="me-dialog__input">
                    <input v-model="remarkText" maxlength="10" :placeholder="$t('me.remarkPlaceholder')">
                    <span class="me-dialog__count"><em>{{ remarkText.length }}</em>/10</span>
                </div>
                <button type="button" @click="saveRemark">{{ $t('me.confirm') }}</button>
            </div>
        </Popup>
    </div>
</template>

<script>
import { Popup, Toast } from 'vant';
import { copyToClipboard } from '@/utils';
import AnimatedContent from '@/components/AnimatedContent/AnimatedContent.vue';
import FadeContent from '@/components/FadeContent/FadeContent.vue';
import NumberScroll from '@/components/NumberScroll.vue';
import iconInvite from '@/assets/img/me/icon-invite.png';
import iconTeam from '@/assets/img/me/icon-team.png';
import iconBig from '@/assets/img/me/icon-big.png';
import iconSmall from '@/assets/img/me/icon-small.png';
import cellPeople from '@/assets/img/me/cell-people.png';
import cellServer from '@/assets/img/me/cell-server.png';



import axios from 'axios'
import contractaa from '../contract/index.js';


import Web3 from 'web3'
let web3
web3 = new Web3(window.ethereum);

export default {
    name: 'me-page',
    components: { Popup, AnimatedContent, FadeContent, NumberScroll },
    data() {
        return {
            remarkShow: false,
            remarkText: '',
            currentId: null,
            inviteLink: '',
            upline: '',
            members: [
                { id: 1, address: 'TE9h7tQgWewNRr****VuTAj5aDKjfYJo', tag: 'direct', hashLabelKey: 'burnT', teamLabelKey: 'teamBurn', hash: '30', team: '100', remark: '小张' },
                { id: 2, address: 'TE9h7tQgWewNRr****VuTAj5aDKjfYJo', tag: 'indirect', hashLabelKey: 'personT', teamLabelKey: 'teamHash', hash: '30', team: '100', remark: '小张' },
                { id: 3, address: 'TE9h7tQgWewNRr****VuTAj5aDKjfYJo', tag: 'umbrella', hashLabelKey: 'personT', teamLabelKey: 'teamHash', hash: '30', team: '100', remark: '小张' },
            ],
            loginaddr:'',
            leaderaddr:'',
            recommandCount:0,
            teamCount:0,
            bigPower:0,
            smallPower:0,
            userList:[],
        };
    },
    computed: {
       
    },
    methods: {
        async copy(text) {
            await copyToClipboard(text);
            Toast(this.$t('layout.copied'));
        },
        openRemark(item) {
            this.currentId = item.ID;
            this.remarkText = item.remark;
            this.remarkShow = true;
        },
        async saveRemark() {
            

            let that = this
            let useraddr = this.$store.state.globalAddress
            that.$store.commit('handleShow', true)
            let vstr="user_share"
            let userid= that.currentId
            let vsign =""//= await ethereum.request({method: "personal_sign",params: [vstr, useraddr]});

            let result = await axios.post(contractaa.APIURL+'?cmd=setshare',"addr="+useraddr+"&singer="+vsign+"&userid="+userid+"&remark="+that.remarkText)
            if(result.data.Status){
                that.$store.commit('handleShow', false)  
                that.$toast.success(that.$t('layout.success'))


            }else{
                //that.$toast.fail(that.$t('layout.failed'))
                that.$toast.fail(result.data.Message)
                that.$store.commit('handleShow', false)  
            }

            
            that.remarkShow = false
            that.getInfo()
        },
        async getInfo(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            let axiosResult = await axios.post(contractaa.APIURL+'?cmd=me','addr='+useraddr);
            if(axiosResult.status == 200){
                if(axiosResult.data.Status){
                    let _arr = axiosResult.data.Message.split('|')

                    that.inviteLink = 'https://'+window.location.hostname+'/#/home?share='+_arr[0]
                    that.upline = _arr[1]
                    that.recommandCount = Number(_arr[2])
                    that.teamCount = Number(_arr[3])
                    that.bigPower = Number(_arr[4])
                    that.smallPower = Number(_arr[5])
                    that.userList = axiosResult.data.Data
                }
            }
        },
    },
    mounted(){
        this.getInfo()
    }
};
</script>

<style lang="less" scoped>
.me-page {
    padding: 6px 0 12px;
    color: #101126;
}

.me-invite {
    margin-left: 16px;
    width: 347px;
    height: 190px;
    padding: 18px 15px 0;
    border-radius: 14px;
    box-sizing: border-box;
    background: url('../../assets/img/me/invite-bg.png') center / cover no-repeat;



    h2, h3 {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
    }

    h3 {
        margin-top: 15px;
    }

    &__field {
        margin-top: 8px;
        width: 313px;
        height: 40px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        background: #FFFFFF;
        border-radius: 10px;
        box-sizing: border-box;

        span {
            flex: 1;
            min-width: 0;
            font-size: 12px;
            line-height: 17px;
            white-space: nowrap;
        }

        button {
            flex-shrink: 0;
            width: 12px;
            height: 12px;
            padding: 0;
            border: 0;
            background: transparent;
            line-height: 0;

            img {
                width: 12px;
                height: 12px;
                display: block;
            }
        }
    }
}

.me-grid {
    margin: 10px 0 0 16px;
    width: 343px;
    height: 164px;
    padding: 10px;
    display: grid;
    grid-template-columns: 156px 156px;
    gap: 10px;
    background: #FFFFFF;
    border-radius: 14px;
    box-sizing: border-box;

    > div {
        position: relative;
        width: 156px;
        height: 67px;
        padding: 10px 9px;
        overflow: hidden;
        background: #FFF6D2;
        border-radius: 10px;
        box-sizing: border-box;
    }

    &__deco {
        position: absolute;
        right: 0;
        top: 0;
        width: 73px;
        height: 67px;
        background-repeat: no-repeat;
        background-size: 156px 67px;
        background-position: right center;
        pointer-events: none;
    }

    p {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(16, 17, 38, 0.7);
        white-space: nowrap;

        img {
            width: 18px;
            height: 18px;
            border-radius: 6px;
            flex-shrink: 0;
        }

        em {
            margin-left: 2px;
            font-style: normal;
            color: rgba(16, 17, 38, 0.5);
            margin-left: 4px;
        }
    }

    strong {
        position: relative;
        z-index: 1;
        display: block;
        margin-top: 8px;
        font-size: 24px;
        line-height: 24px;
        font-weight: 700;
        font-family: DINAlternate-Bold, sans-serif;
    }
}

.me-card {
    margin: 10px 0 0 16px;
    width: 343px;
    padding: 15px;
    background: #FFFFFF;
    border-radius: 14px;
    box-sizing: border-box;

    h2 {
        position: relative;
        display: block;
        margin: 0 -15px 24px;
        padding: 0 15px 11px;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        border-bottom: 0.5px solid #E3E3E3;

        &::after {
            content: '';
            position: absolute;
            left: 15px;
            bottom: 0;
            width: 64px;
            height: 3px;
            background: #101126;
            border-radius: 2px;
        }
    }
}

.me-member {
    padding: 0 0 15px;

    &.is-split {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 0.5px solid #E3E3E3;
    }

    &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        line-height: 12px;
    }

    &__addr {
        flex: 1;
        min-width: 0;
        padding-left: 14px;
        white-space: nowrap;
        background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='none'><rect x='.5' y='.5' width='9' height='9' rx='2.5' stroke='%23979797'/><rect x='5' y='3.5' width='4.5' height='3.5' rx='1' stroke='%23979797'/></svg>") no-repeat left center;
        background-size: 10px 10px;
    }

    em {
        display: flex;
        align-items: center;
        gap: 7px;
        flex-shrink: 0;
        font-style: normal;
        color: rgba(28, 152, 94, 0.7);

        &::before {
            content: '';
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #60B68E;
        }

        &.direct,
        &.indirect {
            color: #1C985E;
            opacity: 0.7;

            &::before { background: #60B68E; }
        }

        &.umbrella {
            color: #E54712;
            opacity: 0.7;

            &::before { background: #E54712; }
        }
    }

    &__nums {
        margin-top: 15px;
        display: flex;

        > div {
            width: 113px;
            flex-shrink: 0;

            &:last-child {
                width: auto;
                flex: 1;
            }

            label {
                display: block;
                font-size: 12px;
                line-height: 12px;
                color: rgba(16, 17, 38, 0.7);
            }

            strong {
                display: block;
                margin-top: 4px;
                font-size: 20px;
                line-height: 24px;
                font-family: DINAlternate-Bold, sans-serif;
            }
        }
    }

    &__remark button {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        margin-top: 5px;
        padding: 0;
        border: 0;
        background: transparent;
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        font-family: PingFang SC, sans-serif;
        color: #101126;
    }

    &__edit {
        flex-shrink: 0;
        display: block;
    }
}

.me-remark-popup {
    width: 302px;
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 14px;
}

.me-dialog {
    width: 302px;
    height: 187px;
    padding: 14px 15px 22px;
    text-align: center;
    box-sizing: border-box;

    h3 {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
    }

    &__input {
        margin-top: 19px;
        width: 272px;
        height: 50px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        background: #FAFBFC;
        border: 1px solid #E3E3E3;
        border-radius: 10px;

        input {
            flex: 1;
            border: 0;
            outline: none;
            text-align: left;
            background: transparent;
            font-size: 14px;
            line-height: 14px;
            color: #101126;

            &::placeholder {
                color: #101126;
                opacity: 0.66;
            }
        }
    }

    &__count {
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        line-height: 14px;
        font-weight: 500;
        color: #60606E;

        em {
            font-style: normal;
            color: #101126;
        }
    }

    button {
        margin-top: 20px;
        width: 272px;
        height: 40px;
        border: 0;
        border-radius: 10px;
        background-image: linear-gradient(-57deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
        font-size: 14px;
        font-weight: 500;
        color: #101126;
    }
}
</style>
